<script lang="ts">
    import { fly } from "svelte/transition";
    import { onMount } from "svelte";
    import { helpWebRtcSettingsVisibleStore } from "../../Stores/HelpSettingsStore";
    import { LL } from "../../../i18n/i18n-svelte";
    import { warningMessageStore } from "../../Stores/ErrorStore";
    import { localUserStore } from "../../Connection/LocalUserStore";
    import Spinner from "../Icons/Spinner.svelte";
    import InputCheckbox from "../Input/InputCheckbox.svelte";

    let notAskAgain = $state(false);

    function refresh() {
        window.location.reload();
    }

    function close() {
        helpWebRtcSettingsVisibleStore.set("hidden");
    }

    function onChangesAskAgain() {
        localUserStore.setNotAskAgainHelpWebRtcSettingsPopup(notAskAgain);
    }

    onMount(() => {
        if (localUserStore.getNotAskAgainHelpWebRtcSettingsPopup()) {
            // Close this popup but show warning message
            warningMessageStore.addWarningMessage($LL.camera.webrtc.content());
            close();
        }
    });

    /* eslint-disable svelte/no-at-html-tags */
</script>

<form
    class="helpCameraSettings z-600 bg-mlight/80 shadow-light backdrop-blur-md rounded-md2 text-mdark self-center pointer-events-auto flex flex-col m-auto w-full md:w-2/3 2xl:w-1/4 text-sm md:text-base"
    onsubmit={(event) => {
        event.preventDefault();
        close();
    }}
    transition:fly={{ y: -50, duration: 500 }}
>
    <section class="mb-0 p-6 pb-2 flex flex-col gap-3">
        {#if $helpWebRtcSettingsVisibleStore === "error"}
            <h3 class="text-center">{$LL.camera.webrtc.title()}</h3>
        {:else}
            <h3 class="text-center">
                <div role="status" class="flex flex-row w-full items-center justify-center gap-3">
                    <span>{$LL.camera.webrtc.titlePending()}</span>
                    <Spinner />
                </div>
            </h3>
        {/if}
        <p class="m-0 font-semibold text-mdanger">{$LL.camera.webrtc.error()}</p>
        <p class="m-0">{$LL.camera.webrtc.content()}</p>
        <ul class="m-0 flex flex-col gap-2 ps-5 list-disc">
            <li>{@html $LL.camera.webrtc.solutionVpn()}</li>
            <li>{@html $LL.camera.webrtc.solutionHotspot()}</li>
            <!-- TODO: Bring the link to the network guide from the admin -->
            <!--<li>{@html $LL.camera.webrtc.solutionNetworkAdmin()}<a href="" target="_blank">{$LL.camera.webrtc.preparingYouNetworkGuide()}</a></li>-->
        </ul>
    </section>
    <section class="flex flex-row items-center px-4">
        <InputCheckbox
            id="askagain"
            bind:value={notAskAgain}
            onchange={onChangesAskAgain}
            label={$LL.camera.webrtc.solutionVpnNotAskAgain()}
        />
    </section>
    <section class="flex flex-row justify-evenly items-center w-full p-4 gap-3">
        <button
            type="button"
            class="btn btn-contrast btn-border flex-1 justify-center"
            onclick={(event) => {
                event.preventDefault();
                refresh();
            }}
        >
            {$LL.camera.webrtc.refresh()}
        </button>
        <button
            type="submit"
            class="btn btn-secondary flex-1 justify-center"
            onclick={(event) => {
                event.preventDefault();
                close();
            }}
        >
            {$LL.camera.webrtc.continue()}
        </button>
    </section>
</form>
